import script from "./group.vue?vue&type=script&setup=true&lang=js"
export * from "./group.vue?vue&type=script&setup=true&lang=js"

import "./group.vue?vue&type=style&index=0&id=e40feebc&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e40feebc"]])

export default __exports__